import React from 'react';
import { Button, Paper, TextField, ClickAwayListener } from '@material-ui/core';
import './PaymentPopper.css';
import withShipment from '../../withShipment';
import { saveCashLeft } from '../../redux/actions/ticketOut';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CLOSING_SHIFT_OPTION } from './constants';

class PaymentPopperTransaction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cashLeft: '',
      selectedEmployeeId: null,
      isTextFieldFocused: false,
      isClosingShift: false,
    };
  }

  handleChange(e) {
    const { name, value } = e.target;

    // Only allow positive integers (no decimals or negative numbers)
    if (/^\d*$/.test(value)) {
      this.setState({ [name]: value });
    }
  }

  handleEmployeeChange = (event, newValue) => {
    if (!newValue) {
      this.setState({
        selectedEmployeeId: null,
        isClosingShift: false,
      });
      return;
    }

    if (newValue.isClosingShift) {
      this.setState({
        selectedEmployeeId: null, // REQUIRED
        isClosingShift: true, // ✅ THIS IS THE KEY
      });
      return;
    }

    this.setState({
      selectedEmployeeId: newValue.userId,
      isClosingShift: false,
    });
  };

  handleClose = () => {
    // Only close if the TextField is not focused
    if (!this.state.isTextFieldFocused) {
      this.props.handleClosePopper();
    }
  };

  handleTextFieldFocus = () => {
    this.setState({ isTextFieldFocused: true });
  };

  handleTextFieldBlur = () => {
    this.setState({ isTextFieldFocused: false });
  };

  handleSave = () => {
    const callback = (error, response) => {
      if (error) {
        this.props.openFeedbackBar('error', response);
      } else {
        this.props.openFeedbackBar('success', response);
      }
      this.setState({ cashLeft: '', selectedEmployeeId: null });
      this.props.handleClosePopper();
    };
    this.props.saveCashLeft(
      {
        cashLeft: this.state.cashLeft,
        userId: this.props.userId,
        modifyUserId: this.props.modifyUserId,
        clockId: this.props.clockId,
        selectedEmployeeId: this.state.selectedEmployeeId,
      },
      callback
    );
  };

  render() {
    const employeeOptions = [
      ...(Array.isArray(this.props.employees)
        ? this.props.employees.filter(
            (e) => e.isOnline === true && e.userId !== this.props.userId
          )
        : []),
      CLOSING_SHIFT_OPTION,
    ];

    const isEmployeeSelected =
      this.state.isClosingShift || this.state.selectedEmployeeId !== null;

    return (
      <ClickAwayListener onClickAway={this.handleClose}>
        <Paper className="payment-popper-container">
          <div className="payment-popper-item rowSpecSuppliers">
            <TextField
              variant="outlined"
              name="cashLeft"
              label="Cash Left"
              required={true}
              value={this.state.cashLeft}
              onChange={this.handleChange.bind(this)}
              onFocus={this.handleTextFieldFocus} // Mark when focused
              onBlur={this.handleTextFieldBlur} // Mark when unfocused
              InputLabelProps={{ shrink: true }}
              style={{
                width: '250px',
                marginRight: this.props.isMobile ? '0px' : '16px',
              }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />

            <Autocomplete
              required={true}
              style={{ width: '250px' }}
              options={employeeOptions}
              getOptionLabel={(option) =>
                [option.firstname, option.lastname].filter(Boolean).join(' ')
              }
              value={
                this.state.isClosingShift
                  ? CLOSING_SHIFT_OPTION
                  : this.state.selectedEmployeeId
                  ? employeeOptions.find(
                      (e) => e.userId === this.state.selectedEmployeeId
                    ) || null
                  : null
              }
              onChange={this.handleEmployeeChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Employee to Send Cash"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              )}
              // Search by Name OR ID
              filterOptions={(options, { inputValue }) => {
                return options.filter((c) => {
                  const fullName = [c.firstname, c.lastname]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase();
                  return fullName.includes(inputValue.toLowerCase());
                });
              }}
            />
          </div>
          <div className="payment-popper-buttons">
            <Button
              variant="contained"
              onClick={this.handleClose}
              style={{ width: '100px', marginRight: '16px' }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={this.handleSave}
              color="primary"
              style={{ width: '100px' }}
              disabled={
                !this.state.cashLeft ||
                this.state.cashLeft === '' ||
                !isEmployeeSelected
              }
            >
              {' '}
              Save
            </Button>
          </div>
        </Paper>
      </ClickAwayListener>
    );
  }
}

const actionCreators = {
  saveCashLeft,
};

export default withShipment(
  {
    actionCreators,
  },
  PaymentPopperTransaction
);
